import { AriaInfo } from '../LogProcessor';

export const OfficeFluidAriaInfo: AriaInfo = {
  token: '6a8929bcfc6d44e9b13fee392ada9cf0-4dea6a88-32c5-404b-8af1-4a43b94ef559-7393',
  namespacePrefix: 'Office.Fluid'
};

export const OfficeFluidTestAriaInfo: AriaInfo = {
  token: '742fa5a288b045e5beab1a2b8e445a71-66618038-43f3-4a1f-a680-59d90da7d572-7251',
  namespacePrefix: 'Office.Fluid'
};
